<div class="mainContainer">
    <div class="filter_show" *ngIf="!showTotalSummary">
        <div class="mi-header">
            <div class="mi-header__main">
                <h2 class="log_track" (click)="backToMessDoDetails()"><i class="fa fa-arrow-left"
                        style="margin-right: 15px; cursor: pointer;"></i>Closed Mess Inventory Details</h2>
                <div class="mi-building-name" *ngIf="messBuildingName">
                    <p class="stock_title">Building Name :</p>
                    <input type="text" class="form-control mi-building-name__input" [ngModel]="messBuildingName"
                        name="messBuildingName" readonly />
                </div>
            </div>
        </div>
    </div>
    <div class="mess-box" *ngIf="!holiday && !showTotalSummary">
        <div class="icon_flex">
            <!-- <p class="stock_title">Stock Date :</p>
            <input matInput [matDatepicker]="mydate" [max]="current" (click)="mydate.open()" [value]="current"
                (dateChange)="onStockDateChange($event)" class="form-control form-date" placeholder="Stock Date" />

            <mat-datepicker-toggle matSuffix [for]="mydate" class="datepic">
            </mat-datepicker-toggle>
             <mat-datepicker #mydate [dateClass]="daysheetDateClass"></mat-datepicker> -->

            <p class="search_title">Search :</p>
            <input type="text" name="" id="" placeholder="Search" (input)="onfilterChange($event)"
                class="form-control search_input">
            <p class="lang_title">Language :</p>
            <select name="itemNameLang" class="form-control item-name-lang" [(ngModel)]="itemNameDisplayLang"
                [class.content--disabled]="status === 'CLOSED'" (ngModelChange)="onItemNameLangChange()">
                <option value="en">English</option>
                <option value="te">Telugu</option>
            </select>
            <div class="btn-list">
                <button type="button" class="add_item_btn" (click)="MenuCard()">
                    <mat-icon class="mi-add-holiday-btn__icon">add</mat-icon>
                    Menu card
                </button>
                <button type="button" class="add_item_btn" (click)="openMessSummaryDialog()">
                    <mat-icon class="mi-add-holiday-btn__icon">add</mat-icon>
                    Supply Building
                </button>
            </div>

            <!-- <button mat-raised-button type="button" class="add_item_btn" (click)="addItem()"
                [disabled]="isDaysheetSubmitDisabled">
                Add Item
            </button> -->
        </div>
        <!-- MESS-INVENTORY-TABLE --->
        <div class="content" style="width: 100%; height: 50%;">
            <ag-grid-angular style="width: 100%; height: 500px;" [rowData]="rowData"
                [pinnedBottomRowData]="pinnedBottomRowData" [columnDefs]="colDefs" [defaultColDef]="defaultColDef"
                (cellValueChanged)="onCellValueChanged($event)" (gridReady)="onGridReady($event)"
                [suppressRowClickSelection]="true" [rowSelection]="'multiple'" [suppressCellFocus]="false"
                [suppressHeaderFocus]="true" [rowHeight]="40" [quickFilterText]="quickFilter"
                [overlayLoadingTemplate]="overlayLoadingTemplate" [overlayNoRowsTemplate]="overlayNoRowsTemplate" />
        </div>
        <!-- 
        <div class="table-total-amount">
            <div class="table-total-amount__label">Total Amount</div>
        </div> -->


        <div class="submit">
            <button type="button" class="sbd__btn" (click)="submit()" >Total Summary</button>
        </div>
    </div>

    <div class="total-summary-panel" *ngIf="!holiday && showTotalSummary && totalSummaryData">
            <div class="total-summary-panel__header">
                <button type="button" class="total-summary-panel__back" (click)="closeTotalSummary()" aria-label="Back">
                    <mat-icon>arrow_back</mat-icon>
                    <span>Back</span>
                </button>
                <h3 class="total-summary-panel__title">Daysheet Total Summary</h3>
                <!-- <span class="total-summary-panel__status" *ngIf="totalSummaryData.status">
                    {{ totalSummaryData.status }}
                </span> -->
            </div>

            <div class="total-summary-panel__meta">
                <!-- <span *ngIf="totalSummaryData.daysheetId">Daysheet ID: {{ totalSummaryData.daysheetId }}</span> -->
                <span><strong class="total-summary-panel__meta-label">Day Sheet Date:</strong> {{ daysheetDate }}</span>
                <span><strong class="total-summary-panel__meta-label">Students:</strong> {{ totalSummaryData.studentCount }}</span>
                <span><strong class="total-summary-panel__meta-label">Employees:</strong> {{ totalSummaryData.employeeCount }}</span>
                <span><strong class="total-summary-panel__meta-label">Sub Staff:</strong> {{ totalSummaryData.subStaffCount }}</span>
                <span><strong class="total-summary-panel__meta-label">Others:</strong> {{ totalSummaryData.visitorsCount }}</span>
                <span><strong class="total-summary-panel__meta-label">Total Cost(₹):</strong> {{ inrGroupedNumber(totalSummaryData.daysheetAmount) }}</span>
                <span *ngIf="totalSummaryPerHeadPrice > 0">
                    <strong class="total-summary-panel__meta-label">Per Head(₹):</strong> {{ inrGroupedNumber(totalSummaryPerHeadPrice) }}
                </span>
                <div class="total-summary-panel__view-toggle">
                    <button type="button" class="total-summary-panel__view-toggle-btn"
                        [class.total-summary-panel__view-toggle-btn--active]="summaryViewMode === 'all'"
                        (click)="setSummaryViewMode('all')">All</button>
                    <button type="button" class="total-summary-panel__view-toggle-btn"
                        [class.total-summary-panel__view-toggle-btn--active]="summaryViewMode === 'summary'"
                        (click)="setSummaryViewMode('summary')">Summary</button>
                </div>
            </div>

            <div class="total-summary-panel__all-view" *ngIf="summaryViewMode === 'all'">
                <div class="total-summary-panel__todays-menu">
                    <div class="total-summary-panel__todays-menu-title">Today's Menu</div>
                    <div class="total-summary-panel__todays-menu-row" *ngFor="let menu of getTodaysMenuList()">
                        <span class="total-summary-panel__todays-menu-scenario">{{ menu.scenarioName }}:</span>
                        <span class="total-summary-panel__todays-menu-items">{{ menu.menuItems }} .</span>
                    </div>
                </div>

                <div class="total-summary-panel__scenario-box">
                    <div class="total-summary-panel__table-wrap">
                        <div class="total-summary-panel__table">
                            <div class="total-summary-panel__thead">
                                <div class="nums__item">Item</div>
                                <div class="num">Rate (₹)</div>
                                <div class="num">Breakfast Qty</div>
                                <div class="num">Lunch Qty</div>
                                <div class="num">Snacks Qty</div>
                                <div class="num">Dinner Qty</div>
                                <div class="num">Total Qty</div>
                                <div class="num">Open Qty</div>
                                <div class="num">Closed Qty</div>
                                <div class="num">Total Cost (₹)</div>
                            </div>
                            <div class="total-summary-panel__tbody">
                                <div class="total-summary-panel__tr" *ngFor="let item of allSummaryRows">
                                    <div class="total-summary-panel__item-name">{{ item.itemName }}</div>
                                    <div class="num">{{ inrGroupedNumber(item.ratePerUnit) }}</div>
                                    <div class="num">{{ item.bfQty }}</div>
                                    <div class="num">{{ item.lunchQty }}</div>
                                    <div class="num">{{ item.snacksQty }}</div>
                                    <div class="num">{{ item.dinnerQty }}</div>
                                    <div class="num">{{ item.totalQty }}</div>
                                    <div class="num">{{ inrGroupedNumber(item.onHandQty) }}</div>
                                    <div class="num">{{ inrGroupedNumber(getSummaryClosedQty(item)) }}</div>
                                    <div class="num">{{ inrGroupedNumber(item.totalCost) }}</div>
                                </div>
                                <div class="total-summary-panel__tr total-summary-panel__tr--empty"
                                    *ngIf="!allSummaryRows.length">
                                    <div class="total-summary-panel__empty-cell">No inventory items</div>
                                </div>
                            </div>
                            <div class="total-summary-panel__scenario-total">
                                <span>Total Cost</span>
                                <span class="total-summary-panel__scenario-total-value">
                                    ₹{{ inrGroupedNumber(allSummaryTotalCost) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="total-summary-panel__scenarios" *ngIf="summaryViewMode === 'summary'">
                <div class="total-summary-panel__scenario-box"
                    *ngFor="let scenario of totalSummaryData.scenarioBasedMenuItemsList">
                    <button type="button" class="total-summary-panel__scenario-title"
                        (click)="toggleSummaryScenarioExpand(scenario)"
                        [attr.aria-expanded]="isSummaryScenarioExpanded(scenario)">
                        <span class="total-summary-panel__scenario-title-text">
                            <span>{{ scenario.scenarioName }}</span>
                            <span class="total-summary-panel__scenario-menu-count">
                                ({{ getSummaryMenuItemCount(scenario) }})
                            </span>
                        </span>
                        <mat-icon class="total-summary-panel__scenario-chevron">
                            {{ isSummaryScenarioExpanded(scenario) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                        </mat-icon>
                    </button>
                    <div class="total-summary-panel__scenario-menu">
                        <span class="total-summary-panel__scenario-menu-label">Menu Items:</span>
                        {{ getSummaryMenuLabel(scenario) }}
                    </div>

                    <div class="total-summary-panel__table-wrap" *ngIf="isSummaryScenarioExpanded(scenario)">
                        <div class="total-summary-panel__table total-summary-panel__table--scenario">
                            <div class="total-summary-panel__thead">
                                <div class="nums__item">Item</div>
                                <div class="num">Rate (₹)</div>
                                <div class="num">{{ getScenarioMealQtyLabel(scenario) }}</div>
                                <div class="num">Total Qty</div>
                                <div class="num">Open Qty</div>
                                <div class="num">Closed Qty</div>
                                <div class="num">Total Cost (₹)</div>
                            </div>
                            <div class="total-summary-panel__tbody">
                                <div class="total-summary-panel__tr"
                                    *ngFor="let item of scenario.saveInventoryBalanceDetails">
                                    <div class="total-summary-panel__item-name">{{ item.itemName }}</div>
                                    <div class="num">{{ inrGroupedNumber(item.ratePerUnit) }}</div>
                                    <div class="num">{{ getScenarioMealQtyValue(scenario, item) }}</div>
                                    <div class="num">{{ item.totalQty }}</div>
                                    <div class="num">{{ inrGroupedNumber(item.onHandQty) }}</div>
                                    <div class="num">{{ inrGroupedNumber(getSummaryClosedQty(item)) }}</div>
                                    <div class="num">{{ inrGroupedNumber(item.totalCost) }}</div>
                                </div>
                                <div class="total-summary-panel__tr total-summary-panel__tr--empty"
                                    *ngIf="!scenario.saveInventoryBalanceDetails?.length">
                                    <div class="total-summary-panel__empty-cell">No inventory items</div>
                                </div>
                            </div>
                            <div class="total-summary-panel__scenario-total">
                                <span>Total Cost</span>
                                <span class="total-summary-panel__scenario-total-value">
                                    ₹{{ inrGroupedNumber(getScenarioSummaryTotalCost(scenario)) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="total-summary-panel__footer">
                <button type="button" class="sbd__btn sbd__btn--ghost" (click)="closeTotalSummary()">Back</button>
                <button type="button" class="sbd__btn" (click)="confirmDaysheetSubmit()"
                    [disabled]="isDaysheetSubmitDisabled || isClosedDaysheet">Close Daysheet</button>
            </div>
        </div>
    <div *ngIf="holiday">
        <div class="hrv">

            <!-- Header -->
            <div class="hrv__header">
                <div class="hrv__icon-wrap">
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 
                 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 
                 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 
                 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" fill="white" />
                    </svg>
                </div>
                <div class="hrv__header-text">
                    <h2 class="hrv__title">Holiday</h2>
                    <p class="hrv__date">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                            style="margin-right:5px; vertical-align:middle;">
                            <path d="M19 4h-1V2h-2v2H8V2H6v2H5C3.89 4 3 4.9 3 
                   6v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 
                   2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z" fill="#6b7280" />
                        </svg>
                        {{ daysheetDate }}
                    </p>
                </div>
            </div>

            <div class="hrv__divider"></div>

            <!-- Body -->
            <div class="hrv__body">
                <div class="hrv__reason-card">
                    <p class="hrv__label">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                            style="margin-right:5px; vertical-align:middle;">
                            <path d="M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 
                   8h-4l-1-2H7V6h5l1 2h5v6z" fill="#6366f1" />
                        </svg>
                        REASON
                    </p>
                    <p class="hrv__reason">
                        {{ holidayReason }}
                    </p>
                </div>
            </div>

            <!-- Footer -->
            <div class="hrv__actions">
                <button class="hrv__btn-cancel" type="button" (click)="closeHoliday()">
                    Cancel
                </button>
                <button class="hrv__btn-ok" type="button" (click)="daysheetCloseHoliday()"
                    [disabled]="isClosedDaysheet">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" style="margin-right:5px;">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="white" />
                    </svg>
                    Daysheet Close
                </button>
            </div>

        </div>
    </div>
</div>

<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>